var _circle, _circle2, _path, _circle3, _line;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBarometera(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 255,
    cy: 255,
    r: 144,
    fill: "#FFFFFF"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 256,
    cy: 256,
    r: 144,
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 12
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M256,200V152M364,256H316m-116,0H152m180-68-24,24m-104,0-24-24M308,300l24,24m-152,0,24-24",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 6
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 256,
    cy: 256,
    r: 24,
    fill: "#ef4444"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 256,
    y1: 284,
    x2: 256,
    y2: 164,
    fill: "none",
    stroke: "#ef4444",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 12
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    dur: "6s",
    values: "-54 256 256; -15 256 256; -36 256 256; 36 256 256; 10 256 256; 115 256 256; -54 256 256",
    repeatCount: "indefinite",
    type: "rotate",
    calcMode: "spline",
    keySplines: ".42, 0, .58, 1; .42, 0, .58, 1; .42, 0, .58, 1; .42, 0, .58, 1; .42, 0, .58, 1; .42, 0, .58, 1",
    keyTimes: "0; .17; .25; .42; .5; .67; 1"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBarometera);
export default __webpack_public_path__ + "static/media/barometera.6619e05e8750aac83dd6baba69f57667.svg";
export { ForwardRef as ReactComponent };